import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { Buttons } from '@app/entities/models/buttons/buttons';
import { ContentModalComponent } from '@app/presentation/components/modals/content-modal/content-modal.component';
import { ModalManager } from '@app/services';

import { MTranslatePipe } from '@mercadona/core/translate';

@Component({
  selector: 'app-ptrab-second-fa-contact',
  imports: [CommonModule, MTranslatePipe, ContentModalComponent],
  templateUrl: './second-fa-contact.component.html'
})
export class SecondFaContactComponent {
  buttons: Buttons[] = [
    {
      text: 'TWO_FACTOR.NEW_PHONE.BUTTON.NOTICE',
      enabled: true,
      onClick: () => this.modalManager.dismissMatModal()
    }
  ];

  constructor(private modalManager: ModalManager) {}
}
